import { PlusOutlined } from '@ant-design/icons';
import {
  MyLeadsFriendlyName,
  MyLeadsSearchQuery,
  SubsectionKeys,
} from '@mm/state/interfaces/myLeads';
import { Dropdown, MenuProps } from 'antd';
import React, { useState } from 'react';
import { EventFilterRow } from './EventFilterRow';
import styles from './EventsFilter.module.css';

type Props = {
  filterParams: MyLeadsSearchQuery;
  setFilterParams: (params: MyLeadsSearchQuery) => void;
};

export const EventsFilter = ({ filterParams, setFilterParams }: Props) => {
  const [selectedEvents, setSelectedEvents] = useState<string[]>(
    SubsectionKeys.customerJourney,
  );

  const items: MenuProps['items'] = SubsectionKeys.customerJourney
    .map(key => ({
      key,
      label: MyLeadsFriendlyName[key],
      onClick: ({ key }) => setSelectedEvents([...selectedEvents, key]),
    }))
    .filter(opt => !selectedEvents.includes(opt.key));

  const onEventDelete = (event: string) => {
    setSelectedEvents(selectedEvents.filter(key => key !== event));
  };

  return (
    <div className={styles.container}>
      <div className={styles.heading}>Event</div>
      {selectedEvents.map(event => (
        <EventFilterRow
          key={event}
          attributeKey={event}
          inputType={event === 'time_on_site' ? 'time' : 'number'}
          withEqual={event === 'web_sessions_count'}
          filterParams={filterParams}
          setFilterParams={setFilterParams}
          onDelete={onEventDelete}
        />
      ))}
      {!!items.length && (
        <Dropdown
          menu={{ items }}
          trigger={['click']}
          getPopupContainer={triggerNode =>
            triggerNode.parentElement || document.body
          }
        >
          <div onClick={e => e.preventDefault()} className={styles.adder}>
            <PlusOutlined /> New Event
          </div>
        </Dropdown>
      )}
    </div>
  );
};
